





































import Component from "vue-class-component";
import CodeSubmission from "@/views/CodeSubmission.vue";
import ImagePresentation from '@/views/ImagePresentation.vue';
import Products from "@/views/Products.vue";
import BasicComponent from "@/global/BasicComponent";

@Component({
  components: {CodeSubmission, Products, ImagePresentation}
})
export default class Home extends BasicComponent {

  code: string = "";
  loading: boolean = false;

  created() {

  }

  mounted() {

  }

  get activeStep() {
    return this.$route.query.step;
  }

  set activeStep(val) {
    this.setStep(val);
  }

  onStepChange(step) {

  }

}
